//
//
//
//
//
//
//
//
//
//
//

import QRCode from 'qrcode';
import { mapState } from 'vuex';
import { mergeQueryParamsWithDeepLink } from '~/utils/helpers';

export default {
  name: 'BaseQrSmart',
  props: {
    size: {
      type: Number,
      default: 112,
    },
    errorCorrectionLevel: {
      type: String,
      default: 'H',
    },
    margin: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '#000000',
    },
    background: {
      type: String,
      default: '#ffffff',
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      qrCodeSrc: '',
    }
  },
  computed: {
    ...mapState('smart', ['url']),
    getSmartLink() {
      if (typeof this.url === 'string') {
        return typeof this.queryParams === 'object' && this.queryParams !== null
          ? mergeQueryParamsWithDeepLink(this.url, this.queryParams)
          : this.url;
      }

      return '';
    },
  },
  watch: {
    getSmartLink() {
      this.generateQr();
    },
  },
  methods: {
    async getQrCode(value) {
      try {
        const result = await QRCode.toDataURL(value, {
          errorCorrectionLevel: this.errorCorrectionLevel,
          margin: this.margin,
          color: {
            dark: this.color,
            light: this.background,
          },
        });
        return result;
      } catch (err) {
        console.error(err);
        return '';
      }
    },
    async generateQr() {
      if (!this.getSmartLink) {
        this.qrCodeSrc = '';
        return;
      }
      this.qrCodeSrc = await this.getQrCode(this.getSmartLink);
    },
  },
  async mounted() {
    await this.generateQr();
  },
}
